import React, { type ElementType, forwardRef, type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./container.module.scss";

const cx = c.bind(styles);

export const Width = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl",
  XXL: "xxl",
} as const;

export type WidthType = (typeof Width)[keyof typeof Width];

export const ContainerElement = {
  ARTICLE: "article",
  ASIDE: "aside",
  DIV: "div",
  FOOTER: "footer",
  HEADER: "header",
  MAIN: "main",
  NAV: "nav",
  SECTION: "section",
  SPAN: "span",
} as const;

export type ContainerElementType = (typeof ContainerElement)[keyof typeof ContainerElement];

export type ContainerProps = Omit<BaseProps, "children"> & {
  children: ReactNode;
  width?: WidthType;
  element?: ContainerElementType;
};

const rootClassName = "purpur-container";

export const Container = forwardRef<HTMLElement, ContainerProps>(
  (
    { children, className, width = "xxl", element: ElementTag = "div" as ElementType, ...props },
    ref
  ) => {
    const classes = cx([rootClassName, `${rootClassName}--${width}`, className]);

    return (
      <ElementTag className={classes} ref={ref} {...props}>
        {children}
      </ElementTag>
    );
  }
);

Container.displayName = "Container";
